import React, { useCallback } from "react";

import PropTypes from "prop-types";

import "./CustomizedTick.scss";

function CustomizedTick(params) {
  const {
    x,
    y,
    payload: { value },
    visibleTicksCount,
    dependencies: { isDrilldown, tickWidth, chartWidth, className, axisColors }
  } = params;
  const minWidth = 59;
  const getLabelWidth = useCallback(() => {
    if (!isDrilldown) {
      return tickWidth - 8;
    }
    if (visibleTicksCount === 1) {
      return chartWidth / 1.5;
    }
    return Math.max(minWidth, chartWidth / visibleTicksCount / 1.2);
  }, [chartWidth, isDrilldown, tickWidth, visibleTicksCount]);

  return (
    tickWidth > minWidth && (
      <foreignObject
        width={getLabelWidth()}
        x={x - 0.5 * getLabelWidth()}
        y={y}
        style={{ color: axisColors.stroke, minHeight: "20px" }}
        className={`bar-chart-tick ${className}`}
      >
        {value}
      </foreignObject>
    )
  );
}

CustomizedTick.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  payload: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,
  visibleTicksCount: PropTypes.number,
  dependencies: PropTypes.shape({
    isDrilldown: PropTypes.bool,
    tickWidth: PropTypes.number,
    chartWidth: PropTypes.number,
    className: PropTypes.string,
    axisColors: PropTypes.shape({
      stroke: PropTypes.string
    })
  }).isRequired
};

export default CustomizedTick;
